import React, {Component} from 'react';

import {ContentDispatch} from 'framework';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {connect} from 'react-redux';

import Accordion from 'app-ui-componentlibrary/dist/go/components/common/accordion/Accordion';

import {compileContent} from 'common/utils';
import ReactHtmlParser from 'react-html-parser';
import _ from 'lodash';

const SHOW_HIDE = 'ShowHide';

export class dynamicAccordion extends Component {
  constructor(props) {
    super(props);

    let activeSectionId =
      props.sections && props.sections.length > 0 ? props.sections[0].id : '';
    this.state = {
      activeSection: activeSectionId,
      panelVisibile: true,
    };
  }

  handleExpand = (e, {name}) => {
    this.setState({
      activeSection: this.state.activeSection === name ? '' : name,
    });
  };
  shouldDisplayNav = (section) => {
    const data = this.props.applicationType;

    return shouldDisplay(data, section.toMatch, section.shouldDisplayRules, this.props);
  };

  render() {
    const {config, dynamicComponent, data, setCurrentFieldList, taskContext} = this.props;

    let sections = config.contents;
    let sectionsRendered = _.compact(
      _.map(sections, (section) => {
        if (section.contents && section.contents[0].type === SHOW_HIDE) {
          if (!this.shouldDisplayNav(section.contents[0])) {
            return null;
          }
        }
        const rightTemplate = () => {
          return `<span class='pull-right'>${compileContent(
            section.rightTemplate,
            this.props
          )}</span>`;
        };
        return {
          id: section.id,
          name: ReactHtmlParser(
            section.name + (section.rightTemplate ? rightTemplate() : '')
          ),
          content: (
            <span>
              <ContentDispatch
                config={section}
                data={data}
                dynamicComponent={dynamicComponent}
                setCurrentFieldList={setCurrentFieldList}
                taskContext={taskContext}
              />
            </span>
          ),
        };
      })
    );

    return (
      <div className="dynamic-Accordion-wrapper textSmall">
        <div id="accordion">
          <Accordion
            sections={sectionsRendered}
            activeSection={this.state.activeSection}
            handleExpand={this.handleExpand}
          />
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    applicationType: _.get(state.dynamicComponent, 'data.payload.applicationType'),
  };
};

export default connect(mapStateToProps, null)(connectDynamic(dynamicAccordion));
